/*******************************************************
 ***************************************** send CV
 *******************************************************/
(function($, window, document, undefined) {
  'use strict';

  $(function() {

    $('a[data-toggle="open-realization"]').click(function(e){
      var target = $(this).attr('href');
      if(target != ""){
        var $ajaxLoaderBackdor = $('<div class="ajax-loader-backdor black"></div>');
        $('body').append($ajaxLoaderBackdor);
        $('body').addClass('open-window');

        var ajax = $.ajax({
          url: target,
          success: function(res){

            var $res = $(res);
            $res.find('.ajax-image-loader');
            $('body').append($res.html()).addClass('open-window');
            $('.ajax-image-loader').find('img[data-src]').each(function(){
              $(this).attr('src', $(this).data('src'));
            });

            setTimeout(function(){
              $('.ajax-image-loader').waitForImages({
                waitForAll: true,
                finished: function() {
                  setTimeout(function(){

                    var $resHtml = $('.ajax-image-loader').html();
                    $('body').append($resHtml);
                    $('.realization-window-wrapp').addClass('in');

                    var windowHeight = $(window).height();
                    var windowWidth = $(window).width();
                    if(windowWidth * 0.8 * 0.58 > windowHeight - 100){
                      var maxWidth = ((windowHeight - 100 ) / 0.58) / windowWidth * 100;
                      $('.realization-window-header').css({'max-width': maxWidth + '%'});
                      $('.realization-window-wrapp .swiper-slide').css({'max-width': maxWidth + '%'});
                    }

                    $ajaxLoaderBackdor.remove();
                    var swiper = new Swiper('.swiper-container-realization-gallery', {
                      pagination: false,
                      slidesPerView: 'auto',
                      loop: true,
                      centeredSlides: true,
                      paginationClickable: true,
                      spaceBetween: 40,
                      speed: 500
                    });
                    $('.ajax-image-loader').remove();
                    $('.realization-window-header .close').click(function(e){
                      $('.realization-window-wrapp').remove();
                      $('body').removeClass('open-window');
                      e.preventDefault();
                    });

                  }, 200);
                }
              });
            }, 10);
        }});

        $ajaxLoaderBackdor.click(function(e){
          ajax.abort();
          $('body').removeClass('open-window');
          e.preventDefault();
        });
      }

      e.preventDefault();
    });

  });

}(jQuery, this, document));